import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Network } from 'lucide-react';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { signUp } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await signUp(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError('Failed to create an account');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-900 px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <Network className="mx-auto h-12 w-12 text-primary-500" />
          <h2 className="mt-6 text-3xl font-bold text-white">Create your account</h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && <div className="text-red-500 text-center">{error}</div>}
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="input w-full"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="input w-full"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button type="submit" className="btn btn-primary w-full">
              Create account
            </button>
          </div>
        </form>
        <div className="space-y-4 text-center">
          <div>
            <Link to="/login" className="text-primary-500 hover:text-primary-400">
              Already have an account? Sign in
            </Link>
          </div>
          <div className="text-sm text-gray-400">
            By creating an account, you agree to our{' '}
            <Link to="/terms" className="text-primary-500 hover:text-primary-400">Terms of Service</Link>
            {' '}and{' '}
            <Link to="/privacy_policy" className="text-primary-500 hover:text-primary-400">Privacy Policy</Link>
          </div>
          <div className="text-sm text-gray-400">
            Questions? Contact{' '}
            <a href="mailto:contact@neosavvy.com" className="text-primary-500 hover:text-primary-400">
              contact@neosavvy.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}